var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4223_3527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0395 0C27.5977 0 29.156 0 30.7143 0C30.8074 0.0365836 30.8985 0.0914589 30.9978 0.105686C31.987 0.249988 32.9844 0.343479 33.9653 0.530462C49.5191 3.51609 59.6406 18.4706 56.3957 33.6569C52.6418 51.2312 33.2472 60.9523 16.6919 53.4059C7.44576 49.1947 2.01768 41.9573 0.310412 32.0655C0.206942 31.468 0.103471 30.8704 0 30.2749C0 28.7079 0 27.1409 0 25.576C0.0413883 25.4479 0.10761 25.324 0.120026 25.1919C0.658074 20.123 2.39638 15.4931 5.50672 11.408C10.2084 5.23755 16.4457 1.51415 24.2184 0.308928C24.8268 0.213404 25.4331 0.103653 26.0395 0ZM23.9225 40.0915C30.7246 33.411 37.4461 26.8117 44.0537 20.3222C42.6341 18.8446 41.1731 17.3264 39.6666 15.7594C34.4165 20.9156 29.2284 26.0109 23.8955 31.2505C21.7227 29.0311 19.5581 26.8198 17.3293 24.5435C15.7648 26.1512 14.2976 27.6633 12.9318 29.0677C16.576 32.724 20.272 36.4291 23.9225 40.0915Z",
    fill: "#3DB54A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4223_3527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 55.9891,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/payment-success.0bbe213b27520928626a7f59bd211211.svg";
export { ForwardRef as ReactComponent };